/** @format */

import { request } from 'src/utils'

// eslint-disable-next-line import/no-anonymous-default-export
export const API = {
  getPromethuesInstance: '/monitor/?Action=ListPrometheusInstances&Version=2025-01-01',
  createPrometheusInstance: '/monitor/?Action=CreatePrometheusInstance&Version=2025-01-01',
  getPrometheusInstanceToken: '/monitor/?Action=GetPrometheusToken&Version=2025-01-01'
}

// 获取
export const getPromethuesInstance = async (params?: any) => {
  const result = await request(API.getPromethuesInstance, {
    data: params || {},
    method: 'GET'
  })
  return result?.data || {}
}

// 创建
export const createPrometheusInstance = async (region: string) => {
  const result = await request(API.createPrometheusInstance, {
    data: {
      Region: region
    },
    method: 'POST'
  })
  return result?.data || {}
}

// 获取Token
export const getPrometheusInstanceToken = async (ControllerID: string) => {
  const result = await request(API.getPrometheusInstanceToken, {
    data: {
      ControllerID
    },
    method: 'GET'
  })
  return result?.data || {}
}

// 预聚合
export const getPrometheusRecordList = async params => {
  const result = await request('/monitor/?Action=ListPrometheusRecords&Version=2025-01-01', {
    data: params,
    method: 'GET'
  })
  return result?.data || {}
}

// 查询预聚合规则列表
export const getPrometheusRecord = async ID => {
  const result = await request('/monitor/?Action=GetPrometheusRecord&Version=2025-01-01', {
    data: { ID },
    method: 'GET'
  })
  return result?.data?.Group
}

// 修改预聚合规则状态
export const updatePrometheusRecordState = async params => {
  const result = await request('/monitor/?Action=UpdatePrometheusRecordStatus&Version=2025-01-01', {
    data: params,
    method: 'PUT'
  })
  return result
}

// 删除预聚合规则状态
export const deletePrometheusRecord = async ID => {
  const result = await request('/monitor/?Action=DeletePrometheusRecord&Version=2025-01-01', {
    data: { ID },
    method: 'DELETE'
  })
  return result
}

// 创建预聚合规则
export const createPrometheusRecord = async params => {
  const result = await request('/monitor/?Action=CreatePrometheusRecord&Version=2025-01-01', {
    data: params,
    method: 'POST'
  })
  console.log('createPrometheusRecord', result)
  return result
}

// 修改预聚合规则
export const updatePrometheusRecord = async params => {
  const result = await request('/monitor/?Action=UpdatePrometheusRecord&Version=2025-01-01', {
    data: params,
    method: 'PUT'
  })
  console.log('updatePrometheusRecord', result)
  return result
}
